import { t } from 'i18next'

import type { WalletBalanceOriginRow } from '~/modules/retailMedia/components/WalletBalanceOrigin/types'

export type OriginsSummary = {
  piCount: number
  hasPreexisting: boolean
}

export const getOriginsSummary = (
  origins: WalletBalanceOriginRow[]
): OriginsSummary | null => {
  const active = origins.filter(row => !row.expired)
  if (!active.length) return null

  return {
    piCount: active.filter(row => row.kind === 'pi').length,
    hasPreexisting: active.some(row => row.kind === 'preexisting')
  }
}

export const formatOriginsLabel = (summary: OriginsSummary) => {
  const parts: string[] = []

  if (summary.piCount > 0) {
    parts.push(
      t('rm:wallet.list.origins.pis', {
        count: summary.piCount
      })
    )
  }

  if (summary.hasPreexisting) {
    parts.push(
      summary.piCount > 0
        ? t('rm:wallet.list.origins.preexisting.joined')
        : t('rm:wallet.list.origins.preexisting.alone')
    )
  }

  return parts.join(t('rm:wallet.list.origins.separator'))
}
